var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-dialog', {
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "capusta_info",
    attrs: {
      "id": "capustaInfo"
    }
  }, [_c('button', {
    staticClass: "capusta_info-close",
    on: {
      "click": _vm.closeInfo
    }
  }), _vm.component ? _c(_vm.component, {
    tag: "component"
  }, [_c('button', {
    staticClass: "capusta_info-done",
    on: {
      "click": _vm.closeInfo
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.ok')) + " ")])]) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }